import React from 'react';
import { BaseIcon } from '../base/BaseIcon';
import { IconProps } from '../types';

export const StatusInfoIcon = React.memo<IconProps>(
  ({
    className = '',
    size = 24,
    color = 'currentColor',
    onClick,
    strokeWidth,
  }) => (
    <BaseIcon
      className={className}
      size={size}
      color={color}
      onClick={onClick}
      viewBox="0 0 24 24"
      strokeWidth={strokeWidth}
    >
      <path
        d="M12.38 8H11.62C11.2776 8 11 7.72242 11 7.38V6.62C11 6.27758 11.2776 6 11.62 6H12.38C12.7224 6 13 6.27758 13 6.62V7.38C13 7.72242 12.7224 8 12.38 8Z"
        fill={color}
      />
      <path
        d="M12.38 18H11.62C11.2776 18 11 17.7224 11 17.38V10.62C11 10.2776 11.2776 10 11.62 10H12.38C12.7224 10 13 10.2776 13 10.62V17.38C13 17.7224 12.7224 18 12.38 18Z"
        fill={color}
      />
      <path
        d="M12 23.75C5.52 23.75 0.25 18.48 0.25 12C0.25 5.52 5.52 0.25 12 0.25C18.48 0.25 23.75 5.52 23.75 12C23.75 18.48 18.48 23.75 12 23.75ZM12 1.75C6.35 1.75 1.75 6.35 1.75 12C1.75 17.65 6.35 22.25 12 22.25C17.65 22.25 22.25 17.65 22.25 12C22.25 6.35 17.65 1.75 12 1.75Z"
        fill={color}
      />
    </BaseIcon>
  ),
);

StatusInfoIcon.displayName = 'StatusInfoIcon';
